import { useRef, useEffect } from "react";
import "./Intro.css";

function Intro({
  paragraphs = [],
  accentColor = "",
  highlightColor = "",
  textColor = "",
}) {
  const textRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.target.dataset.index - b.target.dataset.index)
          .forEach((entry) => {
            entry.target.classList.add("intro-text-visible");
            observer.unobserve(entry.target);
          });
      },
      { threshold: 0.3, rootMargin: "0px 0px -10% 0px" },
    );

    textRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="intro"
      className="intro-section"
      style={{
        "--accent-color": accentColor,
        "--highlight-color": highlightColor,
        "--text-color": textColor
      }}>
      {paragraphs.map((paragraph, index) => {
        const isInverted = index % 2 !== 0;
        return (
          <div
            key={index}
            className={
              isInverted ? "intro-content-inverted" : "intro-content"
            }
          >
            <div
              className="intro-text"
              ref={(el) => (textRef.current[index] = el)}
              data-index={index}
            >
              {paragraph.content}
            </div>
            <img
              src={paragraph.image}
              alt={paragraph.alt}
              loading="lazy"
              fetchPriority="low"
              decoding="async"
            />
          </div>
        );
      })}
    </div>
  );
}

export default Intro;
